import React from "react";
import MultiTreatmentProviderReport from "./MultiTreatmentProviderReport";

/**
 * Provider Report
 *
 * SIMS-8930: this used to branch on whether any of the user's programs had
 * `multiTreatmentPlan`, falling back to a LegacyProviderReport that called
 * backend-1 `GET /reports/provider`. No program uses `!multiTreatmentPlan` any
 * more, so that fallback was unreachable on any supported flow and has been
 * deleted along with its v1 call — same rule as PR #1348.
 *
 * Removing the branch also fixes a flash: the old gate read
 * `programs?.some(...)`, which is falsy while the programs query is still in
 * flight, and this component had no loading guard. The legacy report therefore
 * rendered for a moment on every visit. (No v1 request escaped, because that
 * page's query was `enabled: runReport`.)
 *
 * Note the sibling BeneficiaryReport is NOT equivalent: it gates on
 * `hasMultiTreatmentProgram && settings?.useQlikDashboard`, so with Qlik off it
 * still falls through to its legacy report. That one is a real migration,
 * tracked as SIMS-6602.
 */
const ProviderReport: React.FC = () => {
	return <MultiTreatmentProviderReport />;
};

export default ProviderReport;
